import React, { useState } from 'react'
import { useQuery } from 'jsonapi-react'
import { Star } from 'react-feather'

import { getRequestedCatererIdsFromMeta, cityNameDecorator } from './dashboard-utils'
import logo from 'assets/svg/logo-bg.svg'
import styles from './LeadDashboardPage.module.css'


export default function RequestedTrucks({ lead }) {
  const requestedCatererIds = getRequestedCatererIdsFromMeta(lead)
  const caterersQuery = useQuery(requestedCatererIds?.length > 0 && ['caterers', {
    filter: {
      id: requestedCatererIds,
    },
    include: [
      'photo',
      'logo',
      'cities',
      'caterer_stat',
    ],
  }])

  const caterers = caterersQuery.data

  let [viewAll, setViewAll] = useState(null)

  if (!caterers?.length || caterersQuery.isLoading) {
    return (
      <div className={[styles.card, 'mt-4']}>
        <p className='text-md text-black font-light'>Trucks you've requested quotes from will appear here!</p>
      </div>
    )
  }

  return (
    <div>
      {caterers.slice(0, (viewAll) ? 20 : 3).map((caterer, i) => (
        <div className={[styles.card, 'mt-4']} key={caterer.id}>
          <div className='flex'>
            <div className='border border-gray-400 rounded-md overflow-hidden'>
              <img 
                className='bg-cover h-0 bg-center'
                style={{
                  width: '60px',
                  paddingTop:'100%', 
                  backgroundImage: `url('${caterer.logo?.url || caterer.photo?.url || logo}')`
                }} 
                alt='caterer logo' 
              />
            </div>

            <div className='flex-1 px-4 leading-tight'>
                <p className='text-md text-black font-bold'>{caterer.name}</p>
                {caterer.cities?.length ? (
                  <p className='text-md text-black font-light'>{cityNameDecorator(caterer.cities[0].display_name)}</p>
                  ) : null}
              </div>
              <div className='leading-tight'>
                {caterer.caterer_stat?.total_reviews && caterer.caterer_stat?.average_rating ? (
                  <p className='text-md text-black font-bold'>
                    {caterer.caterer_stat?.average_rating.toFixed(1)}
                    &nbsp;
                    <Star size={12} className='text-yellow inline' fill='#E8C500'/>
                  </p>
                ) : null} 
                {caterer.caterer_stat?.total_bookings && caterer.caterer_stat?.total_bookings > 0 ? (
                  <p className='text-md font-light'>
                    <span className='font-bold text-black'>{caterer.caterer_stat.total_bookings}</span> bookings
                  </p>
                ) : null}
            </div>
          </div>
        </div>

      ))}
      <div className='mt-4'>
        <button className='btn rounded-full px-4 py-1 btn-white text-black' onClick={() => setViewAll(!viewAll)}>
            View {(viewAll) ? 'Less' : 'All'}
        </button>
      </div>
    </div>
  )
  

}
